import { ERequestStatus } from '@r1-frontend/api-domru/api-request/v1/user/request-by-connection';

interface ISortable {
    sort: number | null | undefined,
    requestId?: number,
}

enum ESortResult {
    FIRST_PARAMETER_BEFORE = -1,
    EQUALS = 0,
    FIRST_PARAMETER_AFTER = 1,
}

export function sortFunction(first: ISortable, second: ISortable): ESortResult {
    if (first.sort === second.sort) {
        return ESortResult.EQUALS;
    }

    if (first.sort === null || first.sort === undefined) {
        return ESortResult.FIRST_PARAMETER_AFTER;
    }

    if (second.sort === null || second.sort === undefined) {
        return ESortResult.FIRST_PARAMETER_BEFORE;
    }

    if (first.sort < second.sort) {
        return ESortResult.FIRST_PARAMETER_BEFORE;
    } else if (first.sort > second.sort) {
        return ESortResult.FIRST_PARAMETER_AFTER;
    }

    return ESortResult.EQUALS;
}

export function sortFunctionWithRequestIdOnTop(first: ISortable, second: ISortable): ESortResult {
    if (first.requestId && !second.requestId) {
        return ESortResult.FIRST_PARAMETER_BEFORE;
    }

    if (!first.requestId && second.requestId) {
        return ESortResult.FIRST_PARAMETER_AFTER;
    }

    return sortFunction(first, second);
}

/**
 * По биллинг коду возвращает статус заявки
 *
 * @param {number} status
 * @returns {{ status: string, ok: boolean}}
 */
export const getDataStatus = (status: number): { status: ERequestStatus, ok: boolean } => {
    return {
        status: status ? ERequestStatus.success : ERequestStatus.error,
        ok: !!status,
    };
};

export const retryIfParamIsLocked = (
    fn: () => Promise<any>,
    maxRetries = 10,
    timeOut = 1000,
): Promise<any> => {
    return fn()
        .catch((err) => {
            if (maxRetries <= 0 || (err.response?.data?.message || '').indexOf('PARAM_IS_LOCKED') === -1) {
                throw err;
            }

            return new Promise(resolve => setTimeout(() => resolve(retryIfParamIsLocked(fn, maxRetries - 1)), timeOut));
        });
};
